import { skipHydrate } from 'pinia'

/**
 * 無感刷新 token
 * refreshToken 的過期時間（比如30天）應大於 accessToken 的過期時間（比如2小時）
 * 在 cookie（過期自動銷毀）裡存放: { auth-token: accessToken }
 * 在 localStorage（瀏覽器關閉自動銷毀）裡存放：{ user-info: { username, roles } }
 */
const userInfoInit = { username: '', roles: [] as Array<string> }

export const useUserStore = defineStore('user', () => {
  const { $api } = useNuxtApp()
  const runtimeConfig = useRuntimeConfig()
  const { baseURL } = runtimeConfig.public
  const permissionsStore = usePermissionStore()
  /* state */
  const userInfo = useLocalStorage(`${baseURL.replaceAll('/', '-')}-user-info`, userInfoInit)
  /* actions */
  /* 登入 */
  async function login(data: any) {
    useCookie('auth-token', {
      path: baseURL,
    }) // 初始化 auth-token
    const loginResponse = await $api.v1.Login.Post(data)
    if (isResponseError(loginResponse))
      return
    if (loginResponse) {
      const { username, roles } = loginResponse
      userInfo.value = { username, roles }
      permissionsStore.generateMenus()
    }
    return loginResponse
  }

  async function loginFromRootLawWeb(data: any) {
    useCookie('auth-token', {
      path: baseURL,
    }) // 初始化 auth-token
    const loginResponse = await $api.v1.Login.LoginFromRootLawWeb(data)
    if (isResponseError(loginResponse))
      return
    if (loginResponse) {
      const { username, roles } = loginResponse
      userInfo.value = { username, roles }
      permissionsStore.generateMenus()
    }
    return loginResponse
  }

  /* 前端登出（不呼叫API） */
  async function logOut() {
    const authToken = useCookie('auth-token', {
      path: baseURL,
    })
    authToken.value = null
    userInfo.value = { ...userInfoInit }
    navigateTo('/')
  }
  async function syncUserInfo() {
    const authToken = useCookie('auth-token', {
      path: baseURL,
    })
    if (!authToken.value && userInfo.value.username) {
      userInfo.value = { ...userInfoInit }
    }
  }
  /* 更新 token */
  async function handRefreshToken() {
    await $api.v1.RefreshToken.Post({})
  }
  /**
   * 為了讓 userInfo 能先從客戶端的 LocalStorage 中取值。使用 skipHydrate() 的輔助函數。
   * 詳見：https://pinia.vuejs.org/zh/cookbook/composables.html#ssr
   */
  return { userInfo: skipHydrate(userInfo), login, loginFromRootLawWeb, logOut, syncUserInfo, handRefreshToken }
})
